import { updateKeyInStore } from 'App';
import { countries } from 'countries';
import { states } from 'states';
import * as Yup from 'yup';
import { requiredFiles } from '../../../useValidateQuestionnaire';
import { CitizenshipStateValues, updateKey } from './slice';

export const fields: IBaseField<keyof CitizenshipStateValues>[] = [
  {
    type: 'select',
    name: 'heldCitizenship',
    label: 'Which citizenships do you hold?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    options: [
      {
        label: 'Dual Citizenship (US + Additional)',
        value: 'Dual Citizenship (US + Additional)',
      },
      { label: 'Gave up citizenship', value: 'Gave up citizenship' },
      { label: 'US Citizen', value: 'US Citizen' },
      { label: 'Not a US Citizen', value: 'Not a US Citizen' },
    ],

    dependencies: [
      {
        name: 'countries',
        label: 'Please list other country citizenship(s) that you hold',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        type: 'multi-country',
        predicate: (value) =>
          value === 'Dual Citizenship (US + Additional)' ||
          value === 'Not a US Citizen',
      },
      {
        type: 'radio',
        name: 'greenCardHolderThisYear',
        label: 'Were you a Green Card holder during the filing year?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'Not a US Citizen',
        dependencies: [
          {
            type: 'upload',
            name: 'greencardCopy',
            label: 'Please upload a copy of the Green Card',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
          },
        ],
      },
    ],
  },
  {
    type: 'radio',
    name: 'renounceCitizenship',
    label:
      'Did you renounce US Citizenship or abandon your green card (e.g., I-407) in the filing year?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'radio',
    name: 'everLivedInUs',
    label: 'Did you live outside the US in the year of filing?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'states',
        label: 'Which states were you a resident of?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        type: 'multi-state',
        predicate: (value) => value === 'no',
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
